import { QueryParams } from "@ofqual/portal-core/core/types";
import { AnyAction } from "redux";
import { Activity } from "../domain/Activity";
import { News } from "../domain/News";
import { MODULE_NAME } from "../moduleName";

export interface ActionPayload<T> extends AnyAction {
  type: string;
  payload: T;
}

export const LOADED_DATA = `${MODULE_NAME}/LOADED_DATA`;
export const LOADING_DATA = `${MODULE_NAME}/LOADING_DATA`;

export const LOADING_ITEM = `${MODULE_NAME}/LOADING_ITEM`;
export const LOADED_ITEM = `${MODULE_NAME}/LOADED_ITEM`;

export const LOADING_RESOURCE_VISITS = `${MODULE_NAME}/LOADING_RESOURCE_VISITS`;
export const LOADED_RESOURCE_VISITS = `${MODULE_NAME}/LOADED_RESOURCE_VISITS`;

export const loadingNews = (payload: QueryParams) => ({
  type: LOADING_DATA,
  payload,
});

export const loadedItem = (item: News) => ({
  type: LOADED_ITEM,
  payload: item,
});

export const loadingItem = (id: string) => ({
  type: LOADING_ITEM,
  payload: id,
});

export const loadingResourceVisits = () => ({
  type: LOADING_RESOURCE_VISITS,
});

export const loadedResourceVisits = (activities: Activity[]) => ({
  type: LOADED_RESOURCE_VISITS,
  payload: activities,
});
